export default "__VITE_ASSET__DiweUXwu__"